module.exports = __webpack_public_path__ + "img/projects-6.09e0ea8d.jpg";